import http from "../../http";

export interface wikiData {
  uuid: string;
  name: string;
  source_type: string;
  source_info: {
    url: string;
    type: string;
    file_id: string;
    branch_name: string;
    repo_full_name: string;
  };
  description: string;
  stage_status: {
    init: string;
    analyze: string;
    generate: string;
  };
  excluded_dirs: string[];
  excluded_files: string[];
  others: any;
  timestamp: string;
  update_timestamp: string;
}
// XML 解析结果类型
export interface XmlJsResult {
  wiki_structure: {
    title: { _text: string };
    description: { _text: string };
    sections: {
      section: Array<{
        _attributes: { id: string };
        title: { _text: string };
        pages: { page_ref: Array<{ _text: string }> };
      }>;
    };
    pages: {
      page: Array<{
        _attributes: { id: string };
        title: { _text: string };
        content?: { _text?: string; _cdata?: string };
        description: { _text: string };
        parent_section: { _text: string };
        importance: { _text: "高" | "中" | "低" };
        relevant_files?: { file_path: Array<{ _text: string }> };
      }>;
    };
  };
}
// 获取项目目录
export const getRepoWikiList = (): Promise<{
  code: number;
  data: {
    items: wikiData[];
  };
  message: string;
  status: boolean;
}> => {
  return http.get(`/api/v1/wiki/list?per_page=1000`);
};

export interface contentType {
  content: string;
  title: string;
  uuid: string;
  children: contentType[];
}
// 获取wiki详情
export const getWikiDetail = (
  wiki_id: string
): Promise<{
  code: number;
  data: contentType[];
  message: string;
  status: boolean;
}> => {
  return http.get(`/api/v1/wiki/preview?wiki_id=${wiki_id}`);
};

// 创建wiki
export const createWiki = (
  params: any
): Promise<{
  code: number;
  data: { wiki_id: string };
  message: string;
  status: boolean;
}> => {
  return http.post(`/api/v1/wiki/create`, params);
};
// 开始生成wiki
export const generateWiki = (
  wiki_id: string
): Promise<{
  code: number;
  message: string;
  status: boolean;
}> => {
  return http.get(`/api/v1/wiki/generate?wiki_id=${wiki_id}`);
};

// 取消WIKI排队
export const cancelWiki = (
  wiki_id: string
): Promise<{
  code: number;
  message: string;
  status: boolean;
}> => {
  return http.get(`/api/v1/wiki/cancel?wiki_id=${wiki_id}`);
};

// 查看WIKI进度
export interface WikiprogressType {
  progress: number;
  reason?: string;
  stage_status: {
    init: stageStatus;
    analyze: stageStatus;
    generate: stageStatus;
  };
  position?: number;
}
export type stageStatus = "done" | "processing" | "unprocessed" | "failed" | "";
export const getWikiprogress = (
  wiki_id: string
): Promise<{
  code: number;
  data: WikiprogressType;
  message: string;
  status: boolean;
}> => {
  return http.get(`/api/v1/wiki/progress?wiki_id=${wiki_id}`);
};

// 删除wiki
export const deleteWiki = (
  wiki_id: string
): Promise<{
  code: number;
  message: string;
  status: boolean;
}> => {
  return http.delete(`/api/v1/wiki/delete?wiki_id=${wiki_id}`);
};

// 重新生成wiki
export const resetWiki = (
  wiki_id: string
): Promise<{
  code: number;
  message: string;
  status: boolean;
}> => {
  return http.get(`/api/v1/wiki/reset?wiki_id=${wiki_id}`);
};
// 单模块重新生成wiki
export const moduleResetWiki = (
  uuid: string
): Promise<{
  code: number;
  message: string;
  status: boolean;
}> => {
  return http.get(`/api/v1/wiki/page/generate?page_id=${uuid}`);
};
// 配置wiki
export const editWikiConfig = (
  params: any
): Promise<{
  code: number;
  message: string;
  status: boolean;
}> => {
  return http.post(`/api/v1/wiki/update`, params);
};

// 修改单页wiki
export const editWikiWithPage = (params: {
  uuid: string;
  title: string;
  content: string;
}): Promise<{
  code: number;
  message: string;
  status: boolean;
}> => {
  return http.post(`/api/v1/wiki/page/update`, {
    page_id: params.uuid,
    title: params.title,
    content: params.content,
  });
};

// 修改单页wiki
export const getFreeTimes = (): Promise<{
  code: number;
  message: string;
  status: boolean;
  data: {
    count: number;
  };
}> => {
  return http.get(`/api/v1/wiki/free-times`);
};

// 获取生成文档预计消耗的积分
export const getWikiPoints = (
  wiki_id: string
): Promise<{
  code: number;
  message: string;
  status: boolean;
  data: { points: number; files?: number; lines?: number };
}> => {
  return http.get(`/api/v1/wiki/points?wiki_id=${wiki_id}`);
};
